import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/shared/services/common.service';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { UsersService } from 'src/app/users/users.service';

@Component({
	selector: 'app-site-warnings',
	templateUrl: './site-warnings.component.html',
	styleUrls: ['./site-warnings.component.css']
})
export class SiteWarningsComponent implements OnInit, OnDestroy {
	siteId: number;
	customerId: number;

	enterprisePermissions: any = {};
	permissions: any = {};
	permissionSub: Subscription = new Subscription();
	siteInfoSub: Subscription = new Subscription();
	siteInfo: any = {};

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private usersService: UsersService,
		private sideMenuService: SideMenuService,
		private commonService: CommonService,
		private translateService: TranslateService,
	) { }

	ngOnInit() {
		this.siteId = Number(this.route.parent.snapshot.params['siteId']);
		this.customerId = Number(this.route.parent.snapshot.params['customerId']);

		this.permissionSub = this.usersService.getPermissions(this.siteId).subscribe((permissions: any) => {
			this.enterprisePermissions = permissions;
			this.permissions = permissions.permission;

			if (!this.usersService.hasAccessFunction('show_warnings')) {
				return this.router.navigate(['/unauthorized']);
			}

			this.siteInfoSub = this.sideMenuService.currentSite.subscribe((site: any) => {
				this.siteInfo = site;
				this.commonService.setPageTabTitle(`${this.siteInfo.customer_name} - ${this.siteInfo.name} - ${this.translateService.instant('nav.warnings')}`);
			});
		});
	}

	ngOnDestroy() {
		if (this.siteInfoSub)
			this.siteInfoSub.unsubscribe();
	}
}
